<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">{{ $t("student.credit_summary") }}</h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-30 pl-0">
          <md-field>
            <label>{{ $t("common.program") }}</label>
            <md-select
              v-model="programSelect.value"
              @click="fetchProgramOpts('reFetch')"
            >
              <md-option
                v-for="option in programSelect.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ option.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div
          class="md-layout-item md-size-70 text-right"
          v-if="programSelect.options.length"
        >
          <md-button class="md-warning md-round" @click="exportPDF()"
            >{{ $t("common.export") }}
          </md-button>
        </div>
        <div class="md-layout-item md-size-100 pl-0">
          <md-table v-if="tableDetail.list">
            <md-table-row>
              <md-table-head>
                <span class="font-medium">{{
                  $t("academic_plan.graduation_category")
                }}</span>
              </md-table-head>
              <md-table-head>
                <span class="font-medium">{{
                  $t("academic_plan.needed")
                }}</span>
              </md-table-head>
              <md-table-head>
                <span class="font-medium">{{
                  $t("academic_plan.earned")
                }}</span>
              </md-table-head>
              <md-table-head>
                <span class="font-medium">{{
                  $t("academic_plan.missing")
                }}</span>
              </md-table-head>
            </md-table-row>
            <md-table-row
              v-for="(item, index) in tableDetail.list"
              :key="index + item.name"
            >
              <md-table-cell>{{ item.name }}</md-table-cell>
              <md-table-cell>{{ item.needed }} </md-table-cell>
              <md-table-cell>{{ item.earned }}</md-table-cell>
              <md-table-cell>
                <span :class="{ 'text-[#F44336]': item.missing }">
                  {{ item.missing }}
                </span>
              </md-table-cell>
            </md-table-row>
            <template v-if="tableDetail.total">
              <md-table-row class="border-top-1">
                <md-table-head>
                  <span class="font-medium">{{ $t("common.total") }}</span>
                </md-table-head>
                <md-table-head>
                  <span class="font-medium">
                    {{ tableDetail.total.needed }}
                  </span>
                </md-table-head>
                <md-table-head>
                  <span class="font-medium">
                    {{ tableDetail.total.earned }}
                  </span>
                </md-table-head>
                <md-table-head>
                  <span
                    class="font-medium"
                    :class="{ 'text-[#F44336]': tableDetail.total.missing }"
                  >
                    {{ tableDetail.total.missing }}
                  </span>
                </md-table-head>
              </md-table-row>
            </template>
          </md-table>
          <no-data-found v-else></no-data-found>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { service_paths } from "@/constants/Services";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import { Message } from "@/helpers/utils";

export default {
  name: "credit-summary",
  components: {
    NoDataFound
  },
  props: ["studentData", "isActiveTab"],
  data() {
    return {
      programSelect: {
        value: "",
        options: []
      },
      tableDetail: [],
      listCreditSummary: [],
      totalCreditSummary: [],
      isActive: false
    };
  },
  computed: {
    studentId() {
      return this.$route.params.id;
    }
  },
  methods: {
    async fetchProgramOpts(event) {
      await this.$axios
        .get(
          `${service_paths.students}/${this.studentId}/programs`,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          this.programSelect.options = response.data.sort(
            (currentProgram, newProgram) => {
              return currentProgram.name.localeCompare(newProgram.name);
            }
          );
          if (event === "reFetch") {
            if (!this.programSelect.options.length) {
              Message.error(this.$t("program.program_not_exist"));
              this.programSelect.value = "";
              this.tableDetail = [];
            }
          } else {
            this.programSelect.value = this.programSelect.options[0]?.id;
          }
        });
    },
    async fetchStudentInfo() {
      let params = {
        program_id: this.programSelect.value,
        user_id: this.studentId
      };
      await this.$axios
        .get(`${service_paths.student_information}/credit-summary`, params)
        .then(response => {
          this.tableDetail = response.data;
        });
    },
    exportPDF() {
      this.listCreditSummary = [];
      this.tableDetail.list?.map(list => {
        this.listCreditSummary.push({
          name: list.name,
          needed: list.needed,
          earned: list.earned,
          missing: list.missing
        });
      });
      const total = this.tableDetail.total;
      this.totalCreditSummary = {
        needed: total?.needed,
        earned: total?.earned,
        missing: total?.missing
      };
      const programName = this.programSelect.options.filter(
        program => program.id === this.programSelect.value
      );
      let dataCreditSummary = {
        list_credit_summary: this.listCreditSummary,
        total: this.totalCreditSummary,
        student_code: this.studentData.student_code,
        grade: this.studentData.grade,
        program_name: programName[0].name
      };
      this.$axios
        .post(
          `${service_paths.export}/credit-summary/pdf`,
          dataCreditSummary,
          undefined,
          undefined,
          "blob",
          null,
          false,
          false
        )
        .then(response => {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "credit_summary.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            Message.error(this.$t("common.an_error_occurred"));
          }
        });
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.fetchProgramOpts();
        this.isActive = true;
      }
    },
    "programSelect.value"(newProgram) {
      newProgram && this.fetchStudentInfo();
    }
  }
};
</script>

<style scoped lang="scss">
.border-top-1 {
  border-top: 1px solid rgb(207, 205, 205);
}
.md-table-row:nth-child(2n) {
  background-color: rgb(248, 248, 248);
}
</style>
